import PropTypes from "prop-types";

export const EmployeesIcon = ({ active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
      {...props}>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M12.562 15.974l1.267 1.266 2.533-2.533M10.662 9.157a1.515 1.515 0 00-.275 0 3.683 3.683 0 01-3.558-3.691 3.69 3.69 0 013.691-3.7c2.042 0 3.7 1.658 3.7 3.7 0 2-1.583 3.625-3.558 3.691zM10.52 18.274c-1.516 0-3.024-.384-4.174-1.15-2.017-1.35-2.017-3.55 0-4.892 2.291-1.533 6.05-1.533 8.341 0"></path>
    </svg>
  );
};

EmployeesIcon.propTypes = {
  active: PropTypes.bool
};
